import { PerformanceBasedPayPerformanceMetricsModel } from './performanceBasedPayPerformanceMetrics.model';
import { WorkerViewModel } from './worker.model';
import { UserModel } from './user.model';

interface PerformanceMetricsObject {
  [key: string]: PerformanceBasedPayPerformanceMetricsModel;
}

export enum PublicUtilityType {
  ELECTRICITY = '1',
  GAS = '2',
}

export interface PerformanceBasedPayModel {
  id: number;
  status: string;
  startDate: string;
  endDate: string;
  createdAt: string;
  modifiedAt: string;
  approvedAt: string;
  hoursSpentWithOtherActivities: number;
  otherPerformanceBasedPay: number | string;
  approvedById: number;
  approvedBy: UserModel;
  workerId: number;
  worker: WorkerViewModel;
  performanceBasedPayPerformanceMetrics: PerformanceBasedPayPerformanceMetricsModel[];
  performanceMetricsObject?: PerformanceMetricsObject;
}

export interface NewPerformacePayModel {
  workerIds?: string[] | null;
  allActiveWorkers: string | boolean;
  startDate?: string;
  endDate?: string;
}
